"use client";

import { Accordion, Box, Text, VStack } from "@chakra-ui/react";
import { useTranslations } from "next-intl";
import { SlArrowDown } from "react-icons/sl";
import { PRICING_IDS } from "../_constants/pricing.ids";

const FAQ_KEYS = [
  "canCancel",
  "hasTrial",
  "paymentMethods",
  "freeExpiry",
  "upgradeAnytime",
  "teamPlan",
] as const;

export default function PricingFAQ() {
  const t = useTranslations("pricing.faq");

  return (
    <VStack gap={8} maxW="2xl" mx="auto" w="full">
      <VStack gap={2} textAlign="center">
        <Text
          as="h2"
          fontFamily="heading"
          textStyle={{ base: "2xl", md: "3xl" }}
          fontWeight="bold"
          color="neutral.900"
          letterSpacing="-0.02em"
        >
          {t("heading")}
        </Text>
        <Text textStyle="md" color="neutral.600">
          {t("subheading")}
        </Text>
      </VStack>

      <Box
        w="full"
        bg="white"
        rounded="3xl"
        borderWidth="0.5px"
        borderColor="neutral.200"
        boxShadow="sm"
        px={{ base: 4, md: 6 }}
      >
        <Accordion.Root multiple defaultValue={["canCancel"]} w="full">
          {FAQ_KEYS.map((key) => (
            <Accordion.Item
              key={key}
              id={PRICING_IDS.sections.faqItem(key)}
              value={key}
              border="none"
              borderBottomWidth="1px"
              borderColor="neutral.100"
              _last={{ borderBottom: "none" }}
              scrollMarginTop="5rem"
            >
              <Accordion.ItemTrigger
                justifyContent="space-between"
                py={4}
                px={0}
                _hover={{ bg: "transparent" }}
              >
                <Box
                  flex="1"
                  textAlign="left"
                  fontWeight="semibold"
                  textStyle="md"
                  color="neutral.800"
                  pr={4}
                >
                  {t(`${key}.question`)}
                </Box>
                <Accordion.ItemIndicator asChild>
                  <SlArrowDown
                    size={16}
                    color="var(--chakra-colors-neutral-500)"
                  />
                </Accordion.ItemIndicator>
              </Accordion.ItemTrigger>
              <Accordion.ItemContent>
                <Accordion.ItemBody
                  pb={4}
                  px={0}
                  color="neutral.600"
                  textStyle="sm"
                  lineHeight={1.7}
                >
                  {t(`${key}.answer`)}
                </Accordion.ItemBody>
              </Accordion.ItemContent>
            </Accordion.Item>
          ))}
        </Accordion.Root>
      </Box>
    </VStack>
  );
}
